<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="cols"
        :form-context="formContext"
        icon="inticon-autoclaim_lawyer"
        title="Regress"
        @save="saveRegressData">
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="In-Regressnahme von"
                property="regressType"
                type="autocomplete"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Zustelldatum Klage / Mahnbescheid"
                property="deliveryDateClaimOrCourtOrder"
                required
                type="datepicker"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Klageergebnis"
                property="lawsuitResult"
                type="autocomplete"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                hide-arrows
                label="Quote in %"
                :max="100"
                :min="0"
                property="claimCostQuota"
                required
                step="0.01"
                type="number"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Zuständiges Gericht"
                property="responsibleCourt"
                type="text"/>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import Container from '@services/Container';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'RecordRegressData',
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
        },
        created() {
            this.reloadHandlers.regressDataBasedata = this.reloadRegressData;
        },
        methods: {
            saveRegressData(formContext) {
                const saveFunction = (objectId, postData) => {
                    return recordRepository.saveRegressData(objectId, postData);
                };
                this.saveFormData(formContext, saveFunction);
            },
            reloadRegressData(formContext) {
                const reloadFunction = (objectId, postData) => {
                    return recordRepository.reloadRegressData(objectId, postData);
                };
                this.reloadFormData(formContext, reloadFunction);
            },
        },
    }
</script>
